import HomeHeader from './home-header';
import AdminHeader from './admin-header';

export default {
  HomeHeader,
  AdminHeader,
};
